import { render, staticRenderFns } from "./KETextSection.vue?vue&type=template&id=3ffa2c66&scoped=true&"
import script from "./KETextSection.vue?vue&type=script&lang=ts&"
export * from "./KETextSection.vue?vue&type=script&lang=ts&"
import style0 from "./KETextSection.vue?vue&type=style&index=0&id=3ffa2c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa2c66",
  null
  
)

export default component.exports